import { useAuthContext } from '@myphx-engineering/auth/client';
import {
    AutoScrolltop,
    NavBarProvider,
} from '@myphx-engineering/phx-design-system';

import { PatientProvider } from '../../contexts/patient/PatientProvider';
import { SidebarProvider } from '../../contexts/SidebarProvider';
import { useAppSystemDegradationStatus } from '../../hooks/use-app-system-degradation-status';
import { useFlags } from '../../hooks/use-flags';
import Maintenance from '../maintenance/Maintenance';
import { MyPhxTalkativeInitializer } from '../utility/MyPhxTalkativeInitializer';

import { AppContent } from './AppContent';
import { AppSidebar } from './AppSidebar';

const AppRoot = () => {
    const { downForMaintenance } = useFlags();
    const { isAuthenticated } = useAuthContext();
    const { isActive, disableAuthFlows } = useAppSystemDegradationStatus();
    const showMaintenance =
        downForMaintenance || (isActive && disableAuthFlows && isAuthenticated);

    return (
        <>
            <PatientProvider>
                <MyPhxTalkativeInitializer />
                <NavBarProvider>
                    <SidebarProvider>
                        {showMaintenance ? (
                            <Maintenance />
                        ) : (
                            <>
                                <AppContent />
                                <AppSidebar />
                            </>
                        )}
                    </SidebarProvider>
                </NavBarProvider>
            </PatientProvider>
            <AutoScrolltop />
        </>
    );
};

export default AppRoot;
